import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { StudentAwardsList } from './StudentAwardsList'
import { StudentAwardsReportList } from './StudentAwardsReportList'
import { StudentProgressCheck } from '../ProgressCheckManagement'

const Student911Awards = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id
	const [activeTab, setActiveTab] = useState('studentawards')

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab)
	}

	const tabConfig = [
		{ id: 'studentawards', label: 'Student Awards', type: 'custom' },
		{ id: 'studentawardsreport', label: 'Student Awards Report', type: 'custom' }
	]

	return (
		<StudentTopMenuLayout activeMenu="Awards" pageName="Awards">
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				{/*}
				<div className="card-header border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<button
							type="button"
							className="btn btn-link p-0 me-2"
							data-bs-toggle="collapse"
							data-bs-target="#collapseAwards"
							aria-expanded="false"
							aria-controls="collapseAwards"
						>
							<i className="fa fa-chevron-down"></i>
						</button>
						<h5 className="mb-0 d-inline-block">Awards</h5>
					</div>
				</div>
					{*/}
				<div className="collapse" id="collapseAwards">
					<div className="card-body">
						<Nav tabs>
							{tabConfig.map((tab) => (
								<NavItem key={tab.id}>
									<NavLink className={activeTab === tab.id ? 'active' : ''} onClick={() => toggle(tab.id)} style={{ cursor: 'pointer' }}>
										{tab.label}
									</NavLink>
								</NavItem>
							))}
						</Nav>

						<TabContent activeTab={activeTab} className="mt-3">
							{tabConfig.map((tab) => {
								if (tab.id === 'studentawards') {
									return (
										<TabPane key={tab.id} tabId={tab.id}>
											<StudentAwardsList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
										</TabPane>
									)
								}
								if (tab.id === 'studentawardsreport') {
									return (
										<TabPane key={tab.id} tabId={tab.id}>
											<StudentAwardsReportList studentId={effectiveStudentId} isStudentView={!isInstructorView} />
										</TabPane>
									)
								}
								return null
							})}
						</TabContent>
						<StudentProgressCheck studentId={effectiveStudentId} type="Awards" />
					</div>
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { Student911Awards }
